/**
 * RESOURCES.JS - Configuration centralisée des ressources visuelles
 * 
 * Ce fichier configure UNIQUEMENT les ressources VISUELLES (textures, modèles 3D).
 * Les SONS sont configurés séparément dans config/sounds.js et chargés par Howler.js.
 * 
 * TYPES DE RESSOURCES:
 * - Matcaps: Textures de matériaux (20 au total)
 * - Models: Modèles 3D au format GLB
 * - Textures: Images PNG pour UI, ombres, etc.
 * 
 * UTILISATION:
 * - Chargées via hooks Drei (useGLTF, useTexture)
 * - Préchargées au démarrage de l'application
 * - Accessibles via ResourcesProvider dans toute l'app
 */

export const RESOURCES_CONFIG = {
  // ============================================
  // MATCAPS - Textures de matériaux
  // ============================================
  // Définissent l'apparence des matériaux sans éclairage complexe
  // 20 matcaps au total dans le projet
  matcaps: [
    { name: 'matcapBeige', path: '/models/matcaps/beige.png' },
    { name: 'matcapBlack', path: '/models/matcaps/black.png' },
    { name: 'matcapOrange', path: '/models/matcaps/orange.png' },
    { name: 'matcapRed', path: '/models/matcaps/red.png' },
    { name: 'matcapWhite', path: '/models/matcaps/white.png' },
    { name: 'matcapGreen', path: '/models/matcaps/green.png' },
    { name: 'matcapBrown', path: '/models/matcaps/brown.png' },
    { name: 'matcapGray', path: '/models/matcaps/gray.png' },
    { name: 'matcapEmeraldGreen', path: '/models/matcaps/emeraldGreen.png' },
    { name: 'matcapPurple', path: '/models/matcaps/purple.png' },
    { name: 'matcapBlue', path: '/models/matcaps/blue.png' },
    { name: 'matcapYellow', path: '/models/matcaps/yellow.png' },
    { name: 'matcapMetal', path: '/models/matcaps/metal.png' },
    { name: 'matcapDarkBlack', path: '/models/matcaps/darkBlack.png' },
    { name: 'matcapBlackMetal', path: '/models/matcaps/blackMetal.png' },
    { name: 'matcapChrome', path: '/models/matcaps/chrome.png' },
    { name: 'matcapGlass', path: '/models/matcaps/glass.png' },
    { name: 'matcapOrangeDuckHazzard', path: '/models/matcaps/orangeDuckHazzard.png' },
    { name: 'matcapGold', path: '/models/matcaps/gold.png' },
    { name: 'matcapDarkGray', path: '/models/matcaps/darkGray.png' }
  ],
  
  // ============================================
  // MODÈLES 3D - Fichiers GLB
  // ============================================
  // Modèles 3D avec compression Draco
  models: [
    // Section Intro - Éléments statiques
    // { name: 'introStaticBase', path: '/models/intro/static/base.glb' },
    // { name: 'house', path: '/models/intro/static/house.glb' },
    // { name: 'introStaticCollision', path: '/models/intro/static/collision.glb' },
    
    // Radio - Deux versions (clean et matcap)
    { name: 'radioClean', path: '/models/radio/radio_clean.glb' },
    { name: 'radio', path: '/models/radio/radio_matcap.glb' },
    
  // Low-poly sausage
  //{ name: 'sausageLowpoly', path: '/models/sausage/sausage_lowpoly-matcap.glb' },
  //High poly sausage
  //{ name: 'sausage', path: '/models/sausage/sausage_matcap.glb' },
  { name: 'sausage', path: '/models/sausage/sausage_anim.glb' },
    // Instructions - Labels
    // { name: 'introInstructionsLabels', path: '/models/intro/instructions/labels.glb' }
  ],
  
  // ============================================
  // TEXTURES - Images PNG
  // ============================================
  // Textures pour UI, ombres, instructions, etc.
  textures: [
    // Gradient atlas
    { name: 'gradientAtlas', path: '/textures/textureAtlas.png' }
  ]
}

/**
 * NOTE IMPORTANTE:
 * 
 * Les SONS ne sont PAS gérés ici !
 * Ils sont configurés dans config/sounds.js et chargés par Howler.js
 * dans le AudioProvider.
 * 
 * Cette séparation permet:
 * - Meilleure organisation du code
 * - Gestion optimisée des sons (streaming, decode audio)
 * - Contrôle indépendant volume/mute pour l'audio
 */

